export default __webpack_public_path__ + "static/media/High fiber.43d00ed5.jpg";